import {ElementType} from "react";
import {FaChevronDown} from "react-icons/fa6";

import Button from "@/components/button/Button.tsx";
import {Dropdown} from "@/components/dropdown/Dropdown.tsx";
import {DropdownButtonProps} from "@/components/dropdownButton/DropdownButton.types.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";

export const DropdownButton = <T extends ElementType = typeof Button>({
  title,
  icon = FaChevronDown,
  as,
  className,
  menuProps,
  children,
  ...props
}: DropdownButtonProps<T>) => {
  return (
    <Dropdown className={className}>
      <Dropdown.Toggle as={as ?? Button} icon={as === IconButton ? icon : undefined} {...props}>
        {title}
        <Icon icon={icon} />
      </Dropdown.Toggle>
      <Dropdown.Menu {...menuProps}>{children}</Dropdown.Menu>
    </Dropdown>
  );
};
